import { api_v2 } from 'api/apiUtil';

const NotificationApi = {
  getNotifications(userId, mark_seen) {
    const config = {};
    config.params = {
      offset: 0,
      limit: 25,
      mark_seen
    };
    return api_v2.get(`user/notification/${userId}`, config);
  }
};
export default NotificationApi;
